import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Form, Select, InputNumber, Input, Button, message, Spin, Segmented } from 'antd';
import './ServerManagement.scss';

const { Option } = Select;
const { TextArea } = Input;

const ServerManagement = ({ setTitle }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const fetchServerData = useCallback(async () => {
    try {
      const response = await axios.get('/api/server');
      form.setFieldsValue({
        ...response.data,
        status: response.data.status.toString(),
      });
      setIsLoading(false);
    } catch (err) {
      setError('Failed to fetch server data');
      setIsLoading(false);
    }
  }, [form]);

  useEffect(() => {
    setTitle('EarthVerse CRM - 伺服器管理');
    fetchServerData();
  }, [setTitle, fetchServerData]);

  const handleSave = async (values) => {
    setIsSaving(true);
    try {
      await axios.put('/api/server', values);
      message.success('Server data saved successfully!');

      // Update the update date field
      form.setFieldsValue({
        update_date: new Date().toISOString(),
      });
    } catch (err) {
      message.error('Failed to save server data. Please try again.');
    }
    setIsSaving(false);
  };

  const formatDateToTaiwanTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('zh-TW', {
      timeZone: 'Asia/Taipei',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).format(date);
  };

  if (isLoading) return <div className="server-management"><Spin size="large" /></div>;
  if (error) return <div className="server-management error">{error}</div>;

  return (
    <div className="server-management">
      <h2>伺服器狀態管理</h2>
      <Form form={form} onFinish={handleSave} layout="vertical">
        <Form.Item name="status" label="Status" rules={[{ message: 'Please select a status' }]}>
          <Segmented options={[{ label: 'Active', value: '1' }, { label: 'Inactive', value: '0' }]} />
        </Form.Item>
        {/* <Form.Item name="status" label="Status" rules={[{  message: 'Please select a status' }]}>
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item> */}
        <Form.Item name="version" label="Version (用於APP顯示版本號)" >
          <Input style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="version_number" label="Version Number(用於讓APP自動判斷更新)" >
          <InputNumber min={1} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="update_description" label="Update Description">
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item name="server_ip" label="Server IP" rules={[{ message: 'Please input the server IP' }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Update Date">
          <span className="update-date">{formatDateToTaiwanTime(form.getFieldValue('update_date'))}</span>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isSaving} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ServerManagement;